import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { UploadBannerAPI } from '../redux/actions/UploadBannerAction';
import { showErrorToast, showSuccessToast } from '../helpers/toast';
import { uploadBannerStateReset } from '../redux/slices/UploadBannerSlice';
import { PulseLoader } from 'react-spinners';

const UploadBanner = () => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
  const [base64String, setBase64String] = useState("");
  const { response, loading, error } = useSelector((state) => state.uploadBanner)

  // Convert file → base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // encodes file as base64
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };


  const handleFileChange = async (e) => {
  const file = e.target.files?.[0];
  if (file) {
    // File size in MB
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 3) { // example limit 5MB
      showErrorToast("Image size should not exceed 5MB");
      return;
    }

    // Preview (blob URL for UI)
    const url = URL.createObjectURL(file);
    setPreview(url);

    // Check resolution
    const img = new Image();
    img.src = url;
    img.onload = async () => {
    

      // Example: require minimum 800x400
      if (img.width < 299 || img.height < 49) {
        showErrorToast("Image resolution should be at least 300px50px");
        setPreview(null);
        return;
      }

      // Convert to base64
      const base64 = await fileToBase64(file);
      setBase64String(base64);
    };
    img.onerror = () => {
      showErrorToast("Failed to load image");
      setPreview(null);
    };
  }
};


  const handleUpload = async (e) => {
    e.preventDefault();
    try {
      await dispatch(UploadBannerAPI({ imageBase64: base64String }))
    } catch (err) {
      console.error("Upload failed:", err);
    }
  }

  const handleRemoveImage = () => {
    setPreview(null);
    setBase64String("");
  };


  useEffect(() => {
    if (response) {
      setPreview(null);
      setBase64String("");
      showSuccessToast(response.message)
      dispatch(uploadBannerStateReset());
    }
  }, [response, dispatch])

  useEffect(() => {
    if (error) {
      showErrorToast(error?.data);
      dispatch(uploadBannerStateReset());
    }
  }, [error, dispatch])

  return (
    <>
      <div className="content-wrapper">
        <section className="main-section spacer-y">
          <div className="container">
            <div className="row gy-4">
              <div className="col-12">
                <div className="modal_upload_file">
                  <input
                    type="file"
                    accept="image/*"
                    className="d-none"
                    onChange={handleFileChange}
                    id="dragDropFile"
                  />
                  <label htmlFor="dragDropFile">
                    <span className="vstack align-items-center gap-1">
                      <span>
                        <img src="/assets/images/document-upload.png" />
                      </span>
                      <span>Upload Banner here</span>
                      {/* <span>or</span>
                      <span className="text-primary">Browse</span> */}
                    </span>
                  </label>
                </div>
                <div className="mt-4 mb-3 position-relative">
                  {preview && (
                    <span className="image_preview">
                      <img src={preview || ""} alt="Preview" />
                    </span>
                  )}
                  <button className={`remove_img ${preview !== null ? '' : 'd-none'}`} type='button' onClick={handleRemoveImage}><i className="fas fa-xmark"></i></button>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <button className="btn btn-success" type='button' onClick={handleUpload}>{loading ? <PulseLoader color='#ffffff' size={14} /> : 'Upload'}</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default UploadBanner